import { useEffect, useState } from "react";
import { useTheme } from "../../../components/hooks/useTheme";
import axois from "../../../configs/axois";
import baseURL from "../../../configs/api";
import { CircularProgress, Divider } from "@mui/material";
import { FinancleCardPresentation } from "../../../components/common/FinancleCardPresentation";
import { DataGrid, gridClasses, GridColDef, GridSortModel } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { bookingsStatusColorCode } from "../../../utils/statusColorCode";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import moment from "moment";
import useGeneral from "../../../components/hooks/useGeneral";

type VehicleReservationsProps = {
    idNumber: any;
    vehicleSelectedClassData: any | null;
}

export const VehicleReservations = ({ idNumber, vehicleSelectedClassData }: VehicleReservationsProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { dateFormat }: any = useGeneral();
    const { handleTenantError }: any = useTenant();
    const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);
    const [financleData, setFinancleData] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [filterData, setFilterData] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [columns, setColumns] = useState<GridColDef[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [sortModel, setSortModel] = useState<GridSortModel>([]);
    const [rows, setRows] = useState<any[]>([]);
    const [summaryRow, setSummaryRow] = useState<any | null>(null);

    useEffect(() => {
        const columnsHeader: GridColDef[] = [
            {
                field: "bookingNumber",
                headerClassName: themeStyles.table.headerBg,
                headerName: "Reservation",
                editable: false,
                sortable: true,
                width: 300,
                align: "left",
                renderCell: (params) => {
                    return (
                        <Link to={`/carrental/reservations/editreservation?id=${params?.id}`}
                            style={{
                                color: "var(--app-link-color)",
                                textDecoration: "underline",
                            }}
                        >
                            {params?.value}
                        </Link>
                    )
                }
            },
            {
                field: "pickupDate",
                headerName: "Pickup",
                headerClassName: themeStyles.table.headerBg,
                editable: false,
                sortable: true,
                width: 200,
                align: "left",

            },
            {
                field: "returenDate",
                headerName: "Return",
                headerClassName: themeStyles.table.headerBg,
                editable: false,
                sortable: true,
                width: 200,
                align: "left",
            },
            {
                field: "pickupLocationName",
                headerName: "Pickup Location",
                editable: false,
                headerClassName: themeStyles.table.headerBg,
                sortable: true,
                width: 200,
                align: "left",
            },
            {
                field: "returnLocationName",
                headerName: "Return Location",
                editable: false,
                headerClassName: themeStyles.table.headerBg,
                sortable: true,
                width: 200,
                align: "left",
            },
            {
                field: "fuelAtPickup",
                headerName: "Fuel At Pickup",
                editable: false,
                headerClassName: themeStyles.table.headerBg,
                sortable: false,
                width: 200,
                align: "left",
            },
            {
                field: "fuelAtReturn",
                headerName: "Fuel At Return",
                editable: false,
                headerClassName: themeStyles.table.headerBg,
                sortable: false,
                width: 200
            },
            {
                field: "chargeFuleToClient",
                headerName: "Charge Fule To Client",
                headerClassName: themeStyles.table.headerBg,
                editable: false,
                sortable: false,
                width: 200,
                align: "left",
            },
            {
                field: "odometerAtPickup",
                headerName: "Odometer At Pickup",
                headerClassName: themeStyles.table.headerBg,
                width: 200,
                align: "left",
                editable: false,
                sortable: false,
            },
            {
                field: "extraChargePerMile",
                headerName: vehicleSelectedClassData ? "Extra charge Per Mile" : `Extra miles charge $${vehicleSelectedClassData?.additionalChargeIdforExceededDistance?.toFixed(2)} per mile`,
                headerClassName: themeStyles.table.headerBg,
                editable: false,
                sortable: false,
                width: 200,
                align: "left",
                renderCell: (params) => {
                    return (
                        params.id === 'summary' ? (
                            <span className="font-semibold">{params.value}</span>
                        )
                            : (
                                params.value
                            )
                    )

                }
            },

            {
                field: "totalRevenue",
                headerName: "Total Revenue",
                headerClassName: themeStyles.table.headerBg,
                editable: false,
                sortable: false,
                width: 200,
                align: "left",
                renderCell: (params) => {
                    return (
                        params.id === 'summary' ? (
                            <span className="font-semibold">${params.value}</span>
                        )
                            : (
                                `$${params.value}`
                            )
                    )

                }
            },
            {
                field: "daysRented",
                headerName: "Days Rented",
                headerClassName: themeStyles.table.headerBg,
                editable: false,
                sortable: false,
                width: 200,
                align: "left",
                renderCell: (params) => {
                    return (
                        params.id === 'summary' ? (
                            <span className="font-semibold">${params.value}</span>
                        )
                            : (
                                `$${params.value}`
                            )
                    )

                }
            },
            {
                field: "status",
                headerName: "Status",
                headerClassName: themeStyles.table.headerBg,
                editable: false,
                sortable: false,
                width: 150,
                align: "left",
                renderCell: (params) => {
                    let color = {
                        colorBg: "#000000",
                        colorText: "#000000"
                    };
                    color = bookingsStatusColorCode?.find((color: any) => color?.label === params?.value?.trim()?.toLowerCase()) || {
                        colorBg: "#000000",
                        colorText: "#000000"
                    };

                    return (
                        <div className="flex items-end h-full">
                            <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}>
                                {params.value}
                            </span>
                        </div>
                    );
                }

            },
        ];
        setColumns(columnsHeader)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicleSelectedClassData])



    useEffect(() => {
        if (idNumber?.state && idNumber?.state > 0) {
            axois
                .get(`${baseURL}vehicles/GetVehicleFinanceReport/${idNumber?.state}`, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                .then((response) => {
                    const financleResults = [
                        {
                            label: "Revenue",
                            symbol: "$",
                            count: response.data?.revenue,
                        },
                        {
                            label: "Total Expenses",
                            symbol: "$",
                            count: response.data?.totalExpenses,
                        },
                        {
                            label: "Earnings",
                            symbol: "$",
                            count: response.data?.earnings,
                        },
                        {
                            label: "Total Repairs",
                            symbol: "$",
                            count: response.data?.totalRepirs,
                        },
                        {
                            label: "Other Expenses",
                            symbol: "$",
                            count: response.data?.otherExpenses,
                        },
                        {
                            label: "ROI to Date",
                            count: response.data?.roiToDate,
                        },
                    ]

                    setFinancleData(financleResults);
                    setIsDataLoaded(true);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber?.state])

    useEffect(() => {
        if (idNumber?.state && idNumber?.state > 0) {
            setLoading(true)
            let summaryRevenue = 0;
            let summaryCharge = 0;
            let summaryDaysRented = 0;

            fetch(`${baseURL}reservation/GetReservationsHistoryByVehicle/${idNumber?.state}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const result = data?.map((item: any) => {
                        summaryCharge += item?.extraChargePerMile ? item?.extraChargePerMile : 0;
                        summaryRevenue += item?.totalRevenue ? item?.totalRevenue : 0;
                        summaryDaysRented += item?.daysRented ? item?.daysRented : 0;
                        return {
                            ...item,
                            pickupDate: moment(new Date(item?.pickupDate)).format(dateFormat + " hh:mm a"),
                            returenDate: moment(new Date(item?.returenDate)).format(dateFormat + " hh:mm a"),
                            chargeFuleToClient: item?.chargeFuleToClient ? "Yes" : "No",
                            fuelAtPickup: `${item?.fuelAtPickup ? item?.fuelAtPickup : ''} / 8`,
                            fuelAtReturn: `${item?.fuelAtReturn ? item?.fuelAtReturn : ''} / 8`,
                            extraChargePerMile: item?.extraChargePerMile ? item?.extraChargePerMile : 0,
                            totalRevenue: item?.totalRevenue ? item?.totalRevenue : 0
                        }
                    })

                    const summary = {
                        id: 'summary',
                        bookingNumber: '',
                        pickupDate: '',
                        returenDate: '',
                        pickupLocationName: '',
                        returnLocationName: '',
                        fuelAtPickup: '',
                        fuelAtReturn: '',
                        chargeFuleToClient: '',
                        odometerAtPickup: '',
                        odometerAtReturn: '',
                        extraChargePerMile: summaryCharge,
                        totalRevenue: summaryRevenue,
                        daysRented: summaryDaysRented,
                        status: '',
                    }

                    const reservations = result;
                    setData(reservations);
                    setFilterData(reservations);
                    setRows([...reservations, summary]);
                    setSummaryRow(summary)
                    setLoading(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                    setData([]);
                    setFilterData([]);
                    setLoading(false);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber?.state])

    useEffect(() => {
        setFilterData(
            data?.filter((_: any) =>
                _?.bookingNumber?.toLowerCase()?.includes(searchValue?.toLowerCase()) ||
                _?.status?.toLowerCase()?.includes(searchValue?.toLowerCase())
            ));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue])

    const handleSortModelChange = (model: GridSortModel) => {
        setSortModel(model);

        if (model.length === 0) {

            setRows([...filterData, summaryRow]);
            return;
        }

        const { field, sort } = model[0];

        const sorted = [...filterData].sort((a, b) => {

            const valueA = a[field];
            const valueB = b[field];

            if (valueA < valueB)
                return sort === "asc" ? -1 : 1;

            if (valueA > valueB)
                return sort === "asc" ? 1 : -1;

            return 0;
        });

        setRows([
            ...sorted,
            summaryRow
        ]);
    };

    return (
        <div className={`w-full p-[10px] pb-[40px] flex flex-col gap-2.51`}>
            {
                !isDataLoaded ? (
                    <div className="flex h-[300px] items-center justify-center">
                        <CircularProgress />
                    </div>
                )
                    : (
                        <>
                            <div className="w-full mt-8 mb-4 ml-[10px]">
                                <FinancleCardPresentation data={financleData} />
                            </div>
                            <Divider className={`w-full ${themeStyles.divider.bg}`} />
                            <div className="w-full mt-4">
                                <div className={`w-full border ${themeStyles.main.borderColor} rounded-[16px]`}>
                                    <div className={`flex justify-between items-center p-4 border-b ${themeStyles.main.borderColor}`}>

                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Reservation History</h2>

                                        <div className={`flex px-[5px] py-[6px] items-center gap-2.5 rounded-lg border ${themeStyles.main.borderColor} shadow-sm`}>
                                            <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                                                search
                                            </span>
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                className={`border-none outline-none w-full ${themeStyles.main.textSubHeadingColor} bg-transparent`}
                                                onChange={(e) => setSearchValue(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className={`w-full  -auto`}>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns?.map(col => ({
                                                ...col,
                                                headerClassName: themeStyles.table.headerBg,
                                            }))}
                                            disableRowSelectionOnClick
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 10,
                                                    },
                                                },
                                            }}
                                            pageSizeOptions={[5, 10, 15, 20, 25, 50, 75, 100]}
                                            paginationMode="server"

                                            rowCount={0}
                                            disableColumnMenu
                                            loading={loading}
                                            sortingMode="server"
                                            sortModel={sortModel}
                                            onSortModelChange={handleSortModelChange}
                                            slotProps={{
                                                loadingOverlay: {
                                                    variant: 'skeleton',
                                                    noRowsVariant: 'skeleton',
                                                },
                                            }}
                                            hideFooter={true}
                                            showCellVerticalBorder={true}
                                            sx={{
                                                borderTop: "1px solid #E4E7EC",
                                                border: "none",
                                                fontSize: "12px",
                                                wordWrap: "break-word",
                                                overflow: "visible",
                                                color: themeStyles.table.textColor,
                                                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-actions button, & .MuiTablePagination-displayedRows, & .MuiTablePagination-root': {
                                                    color: themeStyles.table.headerColor,
                                                },
                                                '& .MuiDataGrid-columnHeaders': {
                                                    border: "none",
                                                    color: themeStyles.table.headerColor,
                                                    fontWeight: 700
                                                },
                                                [`& .${gridClasses.cell}`]: {
                                                    py: 1,

                                                },
                                            }}
                                        />
                                    </div>

                                </div>
                            </div>
                        </>
                    )
            }
        </div>
    )
}